window.Viewer = require ('viewerjs');